export const getCookies = () => {
	const cookies = {};
	
	if ( !document.cookie )
	{
		return cookies;
	}
	
	document.cookie.split( ';' ).forEach( ( it ) => {
		const item = it.split( '=' );
		
		cookies[item[0].trim()] = item[1].trim();
	} );
	
	return cookies;
};
